import * as ExcelJS from 'exceljs';
import React, { useRef, useEffect } from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { DateStringFormat } from './dateUtil';

export const exportToXlsx = async (
    data,
    fileName,
    mHeaders,
    mObjData,
    fileName1
) => {

    let orgData = JSON.parse(localStorage.getItem("orgName"));
    let OrgLocName = localStorage.getItem("orgLoc");

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');

    const firstRowStyle = {
        font: {
            bold: true,
            color: { argb: '181a18' }
        },
        fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '4ae81e' }
        },
    };

    const conditionalStyle = {
        font: { bold: true },
        fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'e8f005' }
        }
    };

    const conditionalStyle1 = {
        font: { bold: true },
        fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'e8f005' }
        }
    };


    // =========================================================
    // ORGANIZATION NAME
    // =========================================================

    const orgDataRow = [orgData.text];

    const orgDataCell = worksheet.addRow(orgDataRow);

    orgDataCell.getCell(1).style = {
        font: { bold: true }
    };


    // =========================================================
    // PHYSICAL LOCATION
    // =========================================================

    if (fileName1) {

        const fileNameRow2 = [fileName1];

        const fileNameCell2 = worksheet.addRow([
            "Physical Location:",
            ...fileNameRow2
        ]);

        fileNameCell2.getCell(1).style = {
            font: { bold: true }
        };

        fileNameCell2.getCell(2).style = {
            font: { bold: true }
        };
    }


    // =========================================================
    // FILE NAME
    // =========================================================

    const fileNameRow = [fileName];

    const fileNameCell = worksheet.addRow(fileNameRow);

    fileNameCell.getCell(1).style = {
        font: { bold: false }
    };


    // =========================================================
    // DETAIL HEADERS
    // =========================================================

    const headers = mHeaders
        ? mHeaders
        : Object.keys(data[0]);

    const headerRow = worksheet.addRow(headers);

    headerRow.eachCell((cell, colNumber) => {

        cell.style = firstRowStyle;

        worksheet.getColumn(colNumber).width = 15;

    });


    // =========================================================
    // CHECK IF THIS EXPORT HAS SUMMARY
    // =========================================================
    
    const hasSummary = data.some(
        row =>
            row["Summary"] === "Wastage Summary" ||
            row["Summary"] === "Production Order Totals"
    );


    let summaryMode = false;
    let summaryHeaderAdded = false;


    // =========================================================
    // DATA
    // =========================================================

    data.forEach((row, rowIndex) => {


        // =====================================================
        // EMPTY ROW
        // =====================================================

        if (Object.keys(row).length === 0) {

            worksheet.addRow([]);

            return;
        }


        // =====================================================
        // SUMMARY HEADING
        // =====================================================

        if (
            hasSummary &&
            (
                row["Summary"] === "Wastage Summary" ||
                row["Summary"] === "Production Order Totals"
            )
        ) {

            summaryMode = true;

            summaryHeaderAdded = false;


            const summaryTitleRow = worksheet.addRow([
                row["Summary"]
            ]);


            summaryTitleRow.getCell(1).style = {
                font: {
                    bold: true,
                    color: { argb: 'FFFFFF' }
                },
                fill: {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: '4472C4' }
                }
            };


            return;
        }


        // =====================================================
        // SUMMARY DATA
        // =====================================================

        if (hasSummary && summaryMode) {

            const summaryHeaders = Object.keys(row);


            // -------------------------------------------------
            // Add Summary Header
            // -------------------------------------------------

            if (!summaryHeaderAdded) {

                const summaryHeaderRow =
                    worksheet.addRow(summaryHeaders);


                summaryHeaderRow.eachCell(
                    (cell, colNumber) => {

                        cell.style = firstRowStyle;

                        worksheet.getColumn(colNumber).width = 20;

                    }
                );


                summaryHeaderAdded = true;
            }


            // -------------------------------------------------
            // Add Summary Data
            // -------------------------------------------------

            const summaryDataRow =
                summaryHeaders.map(
                    head => row[head]
                );


            const newRow =
                worksheet.addRow(summaryDataRow);


            newRow.eachCell(
                { includeEmpty: true },
                (cell) => {

                    cell.style = conditionalStyle;

                }
            );


            return;
        }


        // =====================================================
        // NORMAL DETAIL DATA
        // =====================================================

        const dataRow = mObjData
            ? mObjData.map(head => row[head])
            : headers.map(head => row[head]);


        const newRow =
            worksheet.addRow(dataRow);


        // =====================================================
        // EXISTING CONDITIONAL FORMATTING
        // =====================================================

        if (
            row['Particular Name'] === 'Total' ||
            row['Party Name'] === 'Party Total' ||
            row['Party Name'] === 'Invoice Total' ||
            row['Party Name'] === 'Bill Total' ||
            row['Party Name'] === 'Grand Total' ||
            row['UOM'] === 'Total' ||
            row['Particulars'] === "Total" ||
            row["Salesman"] === "Total" ||
            row["Salesman"] === "Grand Total" ||
            row["Location Name"] === "Status" ||
            row["Sale Order Date"] === "No Of Orders" ||
            row["Purchase Order Date"] === "No Of Orders" ||
            row["Item Code"] === "Total Value" ||
            row["Quantity Ordered"] === "% of Total Value" ||
            row["Physical Location"] === "Grand Total"
        ) {

            newRow.eachCell(
                { includeEmpty: true },
                (cell) => {

                    cell.style = conditionalStyle;

                }
            );
        }


        if (row["Location Name"] === "Total") {

            newRow.eachCell(
                { includeEmpty: true },
                (cell) => {

                    cell.style = conditionalStyle1;

                }
            );
        }

    });


    // =========================================================
    // DOWNLOAD EXCEL
    // =========================================================

    await workbook.xlsx.writeBuffer().then((buffer) => {

        const blob = new Blob(
            [buffer],
            {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            }
        );


        const link = document.createElement('a');

        link.href = URL.createObjectURL(blob);

        link.download = fileName + '.xlsx';

        link.click();

    });
};


// =============================================================
// EXPORT TO PDF
// =============================================================

export const exportToPDF = (
    data,
    headerNames,
    fileName
) => {

    const [
        unit,
        size,
        orientation,
        marginLeft
    ] = [
        'pt',
        'A4',
        'landscape',
        40
    ];


    const doc = new jsPDF(
        orientation,
        unit,
        size
    );


    doc.setFontSize(10);


    let orgData =
        JSON.parse(
            localStorage.getItem("orgName")
        );


    const title = fileName;

    const headers = [headerNames];


    let content = {

        startY: 70,

        head: headers,

        body: data.map(
            item => Object.values(item)
        )

    };


    doc.text(
        orgData.text,
        marginLeft,
        45
    );


    doc.text(
        title,
        marginLeft,
        60
    );


    doc.autoTable(content);


    doc.save(
        fileName + ".pdf"
    );
};


// =============================================================
// EXPORT TO PDF WITH GROUP HEADINGS
// (each group gets its own title drawn above its own table,
// e.g. "Party Name : <ledger>" above that ledger's transactions)
// =============================================================

export const exportToPDFWithGroups = (
    groups,
    headerNames,
    fileName
) => {

    const [
        unit,
        size,
        orientation,
        marginLeft
    ] = [
        'pt',
        'A4',
        'landscape',
        40
    ];


    const doc = new jsPDF(
        orientation,
        unit,
        size
    );


    doc.setFontSize(10);


    let orgData =
        JSON.parse(
            localStorage.getItem("orgName")
        );


    const headers = [headerNames];

    const pageHeight = doc.internal.pageSize.getHeight();
    const bottomMargin = 40;


    doc.text(
        orgData.text,
        marginLeft,
        45
    );


    doc.text(
        fileName,
        marginLeft,
        60
    );


    let startY = 90;

    groups.forEach(group => {

        if (startY + 30 > pageHeight - bottomMargin) {
            doc.addPage();
            startY = 55;
        }

        doc.setFontSize(10);
        doc.setFont(undefined, 'bold');

        doc.text(
            group.title,
            marginLeft,
            startY
        );

        doc.setFont(undefined, 'normal');

        doc.autoTable({
            startY: startY + 15,
            head: headers,
            body: group.rows.map(
                item => Object.values(item)
            )
        });

        startY = doc.lastAutoTable.finalY + 35;
    });


    doc.save(
        fileName + ".pdf"
    );
};


// =============================================================
// EXPORT TWO PART PDF
// =============================================================

export const exportTWOPartPDF = (data) => {

    console.log('printData', data);


    const pdf = new jsPDF();


    const pageWidth =
        pdf.internal.pageSize.getWidth();


    const pageHeight =
        pdf.internal.pageSize.getHeight();


    const halfPageWidth =
        pageWidth / 2;


    // =========================================================
    // LIABILITIES
    // =========================================================

    pdf.setPage(1);


    pdf.autoTable({

        tableWidth: halfPageWidth,

        startY: 10,

        margin: {
            left: halfPageWidth
        },

        avoidPageSplit: true,

        head: [
            ['Liabilities', 'Amout']
        ],

        body: data.array1.map(
            item => Object.values(item)
        )

    });


    // =========================================================
    // ASSETS
    // =========================================================

    pdf.autoTable({

        tableWidth: halfPageWidth,

        margin: {
            left: 0
        },

        avoidPageSplit: true,

        head: [
            ['Assets', 'Amout']
        ],

        body: data.array2.map(
            item => Object.values(item)
        )

    });


    pdf.save(
        'my-pdf.pdf'
    );
};


// =============================================================
// MY COMPONENT
// =============================================================

export const MyComponent = () => {

    useEffect(() => {

        // Create a new jsPDF instance
        const doc = new jsPDF();


        // Sample data
        const data = [

            ['Name', 'Age', 'Country'],

            ['John Doe', 30, 'USA'],

            // ... more data ...

        ];


        // Define column headers and data
        const columns = [
            'Name',
            'Age',
            'Country'
        ];


        // Set up autotable
        doc.autoTable({

            head: [columns],

            body: data,

            didDrawPage: (hookData) => {

                const totalPagesExp =
                    '{total_pages_count_string}';


                const pageCount =
                    doc.internal.getNumberOfPages();


                doc.text(
                    'Page ' +
                    hookData.pageNumber +
                    ' of ' +
                    totalPagesExp,
                    10,
                    10
                );


                // Check if there's not enough space
                // for the next table
                if (hookData.pageNumber < pageCount) {

                    // Manually add a page
                    doc.addPage();

                }

            },

        });


        // Save or display the document
        doc.save('table.pdf');

    }, []);


    return (
        <div>
            Your component content goes here
        </div>
    );
};
